import React from 'react';
import classNames from 'classnames';
import { Button } from 'legacy/components/Button';
import { Link } from '@hc/redux-saga-router-plus';

import { VALUE_TYPE_RENTAL, COMP_TYPE_RENTAL } from 'legacy/appstore/constants';

import CompsMapContainer from 'legacy/containers/maps-comps';
import PropertyExplorerValueContainer from 'legacy/containers/property-explorer-value';

import PropertyExplorerSectionHeading from 'legacy/components/PropertyExplorerSectionHeading';
import CompsProperties from 'legacy/components/CompsProperties';
import Loading from 'legacy/components/generic/Loading';
import GlossaryButton from 'legacy/components/GlossaryButton';

import {
  RentalReportSection as rentalAvmTheme,
  CompsSummarySection as theme
} from 'legacy/css-modules';

const RentalCompMap = ({ message, onClickInfo, isReportEditable }) => {
  return (
    <div>
      {message && (
        <div
          className={classNames(
            theme['message-bar'],
            rentalAvmTheme.CompsMessage
          )}
          data-hc-name="rental-comps-message-bar"
        >
          <span className="comps-summary--message-bar-text">{message}</span>
          <GlossaryButton
            dataHcName="rental-comps-info-button"
            onClick={onClickInfo}
          />
        </div>
      )}
      <div
        className={classNames(
          'comps-summary--map-container',
          rentalAvmTheme.MapContainer,
          {
            'report-not-editable': !isReportEditable
          }
        )}
      >
        <CompsMapContainer
          compType={COMP_TYPE_RENTAL}
          disableScrollZoom
          isHidingControls
          disableMobileMarkerPopup
        />
      </div>
    </div>
  );
};

const RentalReportSection = ({
  avmLabel,
  isMonthlyValue,
  selectedAvm,
  selectedAvmKey,
  errorRateForState,
  rentalReportHasLoaded,
  dataHcNames,
  showBarChart,
  hasRentalComps,
  hasRentalAvm,
  title,
  buttonLabel,
  isReportLoaded,
  isReportEditable,
  message,
  addressIds,
  isMobile,
  viewButton,
  hideCompGallery,
  avmSelectorUserEntered,
  handleClickInfo,
  handleChangeUserEnteredValue
}) => {
  return (
    <div data-hc-name={dataHcNames.section} className={rentalAvmTheme.section}>
      <header className="heading-section">
        <PropertyExplorerSectionHeading dataHcName={dataHcNames.header}>
          {title}
        </PropertyExplorerSectionHeading>
      </header>
      <Loading
        loading={!rentalReportHasLoaded}
        spinnerDataHcName="rental-comps-loading-spinner"
        className={rentalAvmTheme.Loading}
      >
        <div>
          <div className={rentalAvmTheme.cell}>
            <PropertyExplorerValueContainer
              valueType={VALUE_TYPE_RENTAL}
              classNameChart={rentalAvmTheme.RentalAvmChart}
            />
            {!isMobile && hasRentalComps && <hr />}
            {isMobile && hasRentalComps && (
              <RentalCompMap
                message={message}
                onClickInfo={handleClickInfo}
                isReportEditable={isReportEditable}
              />
            )}
            {!hideCompGallery && (
              <div className={rentalAvmTheme.RentalCompsSection}>
                <h3>Rental Comparable Properties</h3>
                <CompsProperties
                  addressIds={addressIds}
                  compType={COMP_TYPE_RENTAL}
                  dataHcNames={dataHcNames}
                />
                <div
                  className="comps-summary--button-row"
                  data-hc-name={dataHcNames.button}
                >
                  <Link view={viewButton} options={{ inherit: true }}>
                    <Button disabled={!isReportLoaded} primary>
                      {buttonLabel}
                    </Button>
                  </Link>
                </div>
              </div>
            )}
          </div>
          {!isMobile && (
            <div className={rentalAvmTheme.cell}>
              <RentalCompMap
                message={message}
                onClickInfo={handleClickInfo}
                isReportEditable={isReportEditable}
              />
            </div>
          )}
        </div>
      </Loading>
    </div>
  );
};

export default RentalReportSection;
